import { useTranslations } from '@vocab/react';
import { ButtonLink, IconRocket, IconTick, Stack } from 'braid-design-system';
import type { FC } from 'react';

import { TrackOnMount } from 'src/libs/Analytics';
import {
  DotPointItem,
  ImageModalContent,
  TextGroup,
} from 'src/libs/ImageModal';

import translations from '../../AppPageBlock/FreemiumModal/.vocab';

interface UpgradeAdDialogContentProps {
  link: string;
  titleId: string;
  trackButtonPressed: () => void;
  trackModalDisplayed: () => void;
}

export const UpgradeAdDialogContent: FC<UpgradeAdDialogContentProps> = ({
  link,
  titleId,
  trackButtonPressed,
  trackModalDisplayed,
}) => {
  const { t } = useTranslations(translations);
  return (
    <TrackOnMount onMount={trackModalDisplayed}>
      <ImageModalContent
        titleId={titleId}
        heading={t("Can't find the right candidate?")}
        subheading={t(
          'Paid ads work better for hard-to-fill roles. Upgrade and extend your ad for 30 days.',
        )}
        actions={
          <ButtonLink
            size="small"
            href={link}
            icon={<IconRocket />}
            iconPosition="trailing"
            tone="brandAccent"
            onClick={trackButtonPressed}
            target="_blank"
          >
            {t('Upgrade now')}
          </ButtonLink>
        }
        content={
          <Stack space="medium">
            <DotPointItem
              icon={<IconTick tone="positive" />}
              content={
                <TextGroup
                  heading={t('Get better visibility')}
                  description={t(
                    'Appear more often and for longer in search results.',
                  )}
                />
              }
            />
            <DotPointItem
              icon={<IconTick tone="positive" />}
              content={
                <TextGroup
                  heading={t('Reach more candidates')}
                  description={t(
                    'Be featured in candidate emails and notifications.',
                  )}
                />
              }
            />
            <DotPointItem
              icon={<IconTick tone="positive" />}
              content={
                <TextGroup
                  heading={t('Get AI-powered candidate matches')}
                  description={t(
                    'Access a curated list of candidates who match your requirements.',
                  )}
                />
              }
            />
          </Stack>
        }
      />
    </TrackOnMount>
  );
};
